/* eslint-disable @typescript-eslint/no-unused-vars */
import { useQuery, useMutation } from "@tanstack/react-query";
import { fetch3, fetch4, fetch5 } from "../commonApis/commonApis";
import { useDispatch } from "react-redux";
import { setPickupList, addPickup } from "../features/pickup/pickupSlice";
import {
  setLinehaulList,
  addLinehaul,
} from "../features/linehaul/linehaulSlice";
const url = process.env.REACT_APP_BASE_URL;

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
}

export const useFetchPickupData = (
  page: number,
  limit: number,
  searchFor: string,
) => {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ["pickupData", page, limit, searchFor],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/client/pickup-request/lm?page=${page}&limit=${limit}&searchFor=${searchFor}&type=LM`,
        "get",
      );

      if (!res || !res.data) {
        return res.message;
      }

      dispatch(setPickupList(res.data));
      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

const convertFiltersArrayToObject = (
  filtersArr: Array<Record<string, string>>,
) => {
  const obj: Record<string, string> = {};
  filtersArr?.forEach((f) => {
    const [key, value] = Object.entries(f)[0] || [];
    if (key && value) obj[key] = value;
  });
  return obj;
};

export const useFetchPickupDataFiltered = (
  page: number,
  limit: number,
  searchFor: string,
  filters: Array<Record<string, string>>,
) => {
  const dispatch = useDispatch();

  return useQuery({
    queryKey: ["pickupData", page, limit, searchFor, filters],

    queryFn: async () => {
      const filtersObject = convertFiltersArrayToObject(filters);

      const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
        search: searchFor || "", // ✅ FIXED
        type: "LM",
        ...filtersObject,
      });

      console.log("🔥 API params:", params.toString());

      const res = await fetch3(
        `${url}/api/client/pickup-request/lm?${params.toString()}`,
        "get",
      );

      if (!res || !res.data) return res?.message;

      dispatch(setPickupList(res.data));

      return res.data;
    },

    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchRIWPickupData = (
  page: number,
  limit: number,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: ["pickupData", page, limit],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/client/pickup-request/lm?page=${page}&limit=${limit}&searchFor=COLLECTED&type=LM`,
        "get",
      );
      return res?.data ?? null;
    },
    enabled,
  });
};

export const useAssignReceiverMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/client/pickup-request/assign/staff/`,
        "PATCH",
        payload,
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Vehicle Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ vehicle create request failed:", error.message);
    },
  });
};

export const useAssignDriverMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch4(
        `${url}/api/client/pickup-request/assign/driver`,
        payload,
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Driver Assign successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Driver Assign request failed:", error.message);
    },
  });
};

export const usePickRequestMutation = () => {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch4(
        `${url}/api/client/pickup-request/create/lm`,
        payload,
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      console.log(res?.data, "res?.data");
      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Pickup Genrated successfully:", data);
      dispatch(addPickup(data));
    },
    onError: (error: any) => {
      console.error("❌ Pickup Genrated request failed:", error.message);
    },
  });
};

export const useFetchPickupLocationData = (
  page: number,
  limit: number,
  searchFor: string,
) => {
  return useQuery({
    queryKey: ["pickupLocationData", page, limit, searchFor],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/client/pickup-location/lm?page=${page}&limit=${limit}&searchFor=${searchFor}&type=LM`,
        "get",
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

// Create and update location start
export const usePickupLocationCreateMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      console.log("payload >>>>>>>>>>>>", payload);

      const res: ApiResponse = await fetch4(
        `${url}/api/client/pickup-location/lm`,
        payload,
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Pickup location Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Pickup location create request failed:", error.message);
    },
  });
};

export const useUpdateLocationMutation = () => {
  return useMutation({
    mutationFn: async ({
      id,
      ...payload
    }: {
      id: string;
      [key: string]: any;
    }) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/client/pickup-location/lm/${id}`,
        "PUT",
        payload,
      );

      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Location updated successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Location update failed:", error.message);
    },
  });
};

export const useDeleteLocationMutation = () => {
  return useMutation({
    mutationFn: async (id: string) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/client/pickup-location/lm/${id}`,
        "DELETE",
      );

      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Location deleted successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Location delete failed:", error.message);
    },
  });
};

export const useSetDefaultLocationMutation = () => {
  return useMutation({
    mutationFn: async (id: string) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/client/pickup-location/lm/default/${id}`,
        "PATCH",
      );

      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Location set as default successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Location set as default failed:", error.message);
    },
  });
};
// Create and update location End

// --------------------> Get All Vehicles <--------------------

export const useFetchAllVehicle = () => {
  return useQuery({
    queryKey: ["vehicleData"],
    queryFn: async () => {
      const res = await fetch3(`${url}/api/vehicle/all`, "get");

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const usePickupLocationtAlltData = () => {
  return useQuery({
    queryKey: ["pickupLocationtAllList"],
    queryFn: async () => {
      const res = await fetch3(`${url}/api/client/pickup-location/all`, "get");

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const usePickupLocationClientAddressData = (clientId?: string) => {
  return useQuery({
    queryKey: ["pickupLocationtAllList", clientId],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/client/pickup-location/byClient/${clientId}`,
        "get",
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    enabled: !!clientId,
    staleTime: 1000 * 60 * 1,
  });
};
export const usePickupAllIdData = () => {
  return useQuery({
    queryKey: ["pickupIdAllList"],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/client/pickup-request/all-pickuplist`,
        "get",
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchLmClientOrdersData = (
  page: number,
  limit: number,
  searchFor: string,
  clientId: string,
  loadOrder: boolean,
) => {
  return useQuery({
    queryKey: [
      "pickupLocationData",
      page,
      limit,
      searchFor,
      loadOrder,
      clientId,
    ],
    queryFn: async () => {
      if (!loadOrder || !clientId) {
        return null; // prevents accidental call
      }

      const res = await fetch3(
        `${url}/api/orders/new/client?page=${page}&limit=${limit}&searchFor=${searchFor}&type=LM&clientId=${clientId}`,
        "get",
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data;
    },
    enabled: !!loadOrder && !!clientId, // double check
    staleTime: 1000 * 60 * 5,
  });
};
export const useFetchPickListShipment = (
  page: number,
  limit: number,
  searchFor: string,
  pickupId: string,
) => {
  return useQuery({
    queryKey: ["pickupLocationData", page, limit, searchFor, pickupId],
    queryFn: async () => {
      if (!pickupId) {
        return null; // prevents accidental call
      }

      const res = await fetch3(
        `${url}/api/client/pickup-request/shipments/${pickupId}?page=${page}&limit=${limit}&searchFor=${searchFor}&type=LM`,
        "get",
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data;
    },
    enabled: !!pickupId,
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchPickCollectFetch = (
  page: number,
  limit: number,
  searchFor: string,
  pickupId: string,
) => {
  return useQuery({
    queryKey: ["pickupLocationData", page, limit, searchFor, pickupId],
    queryFn: async () => {
      if (!pickupId) {
        return null; // prevents accidental call
      }

      const res = await fetch3(
        `${url}/api/client/pickup-request/list-by-manifest/${pickupId}?page=${page}&limit=${limit}&searchFor=${searchFor}&type=LM`,
        "get",
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data;
    },
    enabled: !!pickupId,
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchPickListShipmentById = (
  page: number,
  limit: number,
  searchFor: string,
  pickupId: string,
) => {
  return useQuery({
    queryKey: ["pickupLocationData", page, limit, searchFor, pickupId],
    queryFn: async () => {
      if (!pickupId) {
        return null;
      }

      const res = await fetch3(
        `${url}/api/client/pickup-request/shipmentsById/${pickupId}?page=${page}&limit=${limit}&searchFor=${searchFor}&type=LM`,
        "get",
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data;
    },
    enabled: !!pickupId,
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchRIWPickListShipmentById = (
  pickupId: string,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: ["pickupShipments", pickupId],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/client/pickup-request/shipmentsById/${pickupId}?type=LM`,
        "get",
      );
      return res?.data ?? [];
    },
    enabled,
  });
};

// For Linehaul by id
export const useFetchLinehaulListShipmentById = (
  manifestId: string,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: ["linehaulShipments", manifestId],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/linehaul-manifest/shipments/${manifestId}?type=LM`,
        "get",
      );
      return res?.data ?? [];
    },
    enabled,
  });
};

// For Pickup Verification RIW
export const usePickRequestInboundMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch4(
        `${url}/api/client/pickup-request/riw/verification`,
        payload,
      );

      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Pickup Request Inbound successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Pickup Request Inbound failed:", error.message);
    },
  });
};

export const usePickCollectedMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch4(
        `${url}/api/client/pickup-request/manifest-collected`,
        payload,
      );

      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Pickup Request Inbound successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Pickup Request Inbound failed:", error.message);
    },
  });
};

export const usePickRequestInboundAWBMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch4(
        `${url}/api/client/pickup-request/awb/verify`,
        payload,
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Pickup Request AWB successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Pickup Request AWB failed:", error.message);
    },
  });
};

// Linehaul Manifes API's

export const useLinehualManifestGenerateMutation = () => {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: async (payload: {
      fromWarehouseId: string;
      toWarehouseId: string;
      linehaul_load_list: {
        type: string;
        awbs: string[];
      }[];
    }) => {
      const res: ApiResponse = await fetch4(
        `${url}/api/linehaul-manifest/`,
        payload,
      );

      if (!res.success) {
        throw new Error(res.message || "Failed to create linehaul manifest");
      }

      return res.data;
    },

    onSuccess: (data: any) => {
      console.log("✅ Linehaul Manifest Created:", data);

      dispatch(addLinehaul(data));
    },

    onError: (error: any) => {
      console.error("❌ Linehaul creation failed:", error.message);
    },
  });
};

// For View Details List
export const useFetchLinehaulManifestById = (id: string, scanCode: string) => {
  return useQuery({
    queryKey: ["linehaulManifestData", id, scanCode],
    queryFn: async () => {
      if (!id || scanCode) {
        return null;
      }

      const res = await fetch3(
        `${url}/api/linehaul-manifest/${id}?scanCode=${scanCode}`,
        "get",
      );

      if (!res || !res.data) {
        return res.message;
      }
      return res.data;
    },
    enabled: !!id && !!scanCode,
    staleTime: 1000 * 60 * 5,
  });
};

// For Sacn paste id
export const useFetchLinehaulManifestScanById = (
  id: string,
  scanCode: string,
) => {
  return useQuery({
    queryKey: ["linehaulManifest", id, scanCode],

    queryFn: async () => {
      if (!id || !scanCode) return null;

      const res = await fetch3(
        `${url}/api/linehaul-manifest/${id}?scanCode=${scanCode}`,
        "get",
      );

      return res?.data;
    },

    enabled: !!id && !!scanCode,
  });
};

export const useAssignAssignlinehaulVehicleMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/linehaul-manifest/assign-driver`,
        "PATCH",
        payload,
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Assign Driver successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Assign Driver request failed:", error.message);
    },
  });
};

export const useLineHaulAllCompanyListData = () => {
  return useQuery({
    queryKey: ["lineHaulAllCompany"],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/lineHaul/all-company-request/`,
        "get",
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useAssignReceiverLinehaulManifestMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/linehaul-manifest/assign-staff/`,
        "PATCH",
        payload,
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Vehicle Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ vehicle create request failed:", error.message);
    },
  });
};

export const useFetchLinehualManifestData = (
  page: number,
  limit: number,
  searchFor: string,
) => {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ["pickupData", page, limit, searchFor],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/linehaul-manifest/?page=${page}&limit=${limit}&searchFor=${searchFor}&type=LM`,
        "get",
      );

      if (!res || !res.data) {
        return res.message;
      }
      dispatch(setLinehaulList(res.data));
      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchRIWLinehualManifestData = (
  page: number,
  limit: number,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: ["linehaulData", page, limit],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/linehaul-manifest/?page=${page}&limit=${limit}&searchFor=ASSIGNED&type=LM`,
        "get",
      );
      return res?.data ?? null;
    },
    enabled,
  });
};

export const useLineHaulRequestInboundAWBMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/linehaul-manifest/awb-verify`,
        "PATCH",
        payload,
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("Linehaul Request AWB successfully", data);
    },
    onError: (error: any) => {
      console.error("❌ Linehual Request AWB failed:", error.message);
    },
  });
};

export const useLineHaulRequestInboundMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/linehaul-manifest/riw-verification`,
        "PATCH",
        payload,
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ LineHaul Request Inbound successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ LineHaul Request Inbound failed:", error.message);
    },
  });
};
function dispatch(arg0: { payload: any[]; type: "pickup/setPickupList" }) {
  throw new Error("Function not implemented.");
}
